import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';
import { FeatureToggleService, GlobalEventBusService, LoggerService, hd } from '@nx-fe/services';
import * as quill from 'quill';
import { Observable, Subscription, SubscriptionLike, interval, Subject } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
// import { ModalDialogService } from '@nx-fe/shared-dialogs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { XsI18nPipe } from '@nx-fe/pipes';
import { GlobalEvents } from 'app/core/global-event-constants';
import { IFileInfo } from 'app/modules/remote-control/file-manager/fileData';
import moment from 'moment';
import { DeviceStateRegistryService } from 'app/modules/remote-control/services/device-state-registry.service';
import { WorkPanelType } from 'xsmodules/remote-control/services/work-panel-manager.service';
import { AttachmentService, IAttachmentServiceConfig } from 'xsmodules/ticket/services/attachment.service';
import { DeviceCaptureActivityTypes, TicketPageService } from 'xsmodules/ticket/ticket-page.service';
import {
  Activity,
  ActivityTypeEnum,
  AttachmentActivity,
  isDeviceCaptureActivity,
  isDeviceSnapshotActivity,
} from 'xsmodules/ticket/ticket.model';
import { FileSaveParams, PromptDialogComponent } from 'xsshared/components/prompt-dialog/prompt-dialog.component';

export interface IFilePreviewBindings {
  /** Callback when attachment preview should be closed */
  attachmentPreviewClosed: Function;
}

/** Supported FilePreview Error types */
export const enum FilePreviewErrorType {
  None = 0,
  NotFound = 1,
  NoPreview = 2,
  TooLarge = 3,
}

export interface IFilePreviewErrorContent {
  title: string;
  subtitle: string[];
  candownload: boolean;
  imageUrl: string;
}

@Component({
  selector: 'xs-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss'],
})
export class FilePreviewComponent implements OnInit, OnDestroy {
  // see IFilePreviewBindings.attachmentPreviewClosed
  @Output() attachmentPreviewClosed = new EventEmitter<number>();

  /** The preview URL */
  previewUrl: string;

  /** The attachment activity */
  activity: AttachmentActivity;

  /** The attachment activity */
  currentactivitycollection: AttachmentActivity[];

  /** Holds an error message encountered while loading a preview */
  error: string;

  displayName = '';

  /** Log file data to preview in the preview panel */
  logfileData = '';

  /** Quill rich text editor instance */
  quillEditor: quill.Quill;

  /** check if the action/process/task is in the loading state*/
  isLoading = true;

  isLoadingRemaingtext = false;

  /** Hold the search input text */
  searchInputText = '';

  /** Hold the quill editor contents */
  editorContents = '';

  foundValues: number[];
  previewAreaScrollBarTopPosition = 0;
  previewAreaScrollBarHeightPosition = 0;
  copypreviewAreaScrollBarTopPosition = 0;
  copypreviewAreaScrollBarHeightPosition = 0;
  MinimizedStartdUnbind: Subscription;
  resizeTextAreaEndUnbind: Subscription;
  associationBarMinimizedSub: Subscription;
  RestoredStartUnbind: Subscription;
  fileList: any[] = [];
  selectedFile = 0;
  activitytype = '';
  isActivityIcon = false;
  isADBLogActivity = false;
  filePreviewErrorContent: IFilePreviewErrorContent;

  private results: Array<number> = [];
  private matchSearchedResults: Array<number> = [];
  private timeoutvariable: Array<any> = [];
  private selectedtextIndex = 0;
  private maxPreviewFileSize = 0;
  private currentIndexSelectedbyUser = 0;
  private previousSelectedtextIndex = 0;
  private currentIndexofHighlightedtext = 0;
  private performSearchSubscription: SubscriptionLike;
  /** The smallest download extend interval supported by this class. */
  private _minimumDownloadExtendInterval = 60000;
  private ADBFileName = 'ADB.LOG';
  private timeoutId: any;
  private deviceName: string;
  private ADBLogDate: string;
  private rcBarMinimizedSub: Subscription;
  private rcBarRestoredSub: Subscription;
  private associationBarRestoredSub: Subscription;
  private activityDeletedSub: Subscription;
  private attachmentPreviewUnbind: Subscription;
  private remoteControlStartedUnbind: Function;
  private onClearPreview$ = new Subject<void>();

  constructor(
    // private $scope: ng.IScope,
    // private $rootScope: ng.IRootScopeService,
    private $log: LoggerService,
    // private $element: JQuery,
    private $filter: XsI18nPipe,
    // private $interval: ng.IIntervalService,
    private attachmentService: AttachmentService,
    private deviceStateRegistry: DeviceStateRegistryService,
    public featureToggleService: FeatureToggleService,
    // private $timeout: ng.ITimeoutService,
    private globalEventBusService: GlobalEventBusService,
    private dialog: MatDialog, // private $uibModal: ModalDialogService
    private ticketPageService: TicketPageService
  ) {}

  /** Called by angular when the component has fiished linking and the DOM is ready */
  ngOnInit() {
    // Listen for attachment preview event
    this.attachmentPreviewUnbind = this.globalEventBusService.register(
      GlobalEvents.previewAttachment,
      (activity: Activity) => {
        this.searchInputText = '';
        this.selectedFile = 0;
        this.clearTimeout();
        if (activity !== null && !isDeviceSnapshotActivity(activity)) {
          if (
            activity.activityTypeId === ActivityTypeEnum.attachment ||
            activity.activityTypeId === ActivityTypeEnum.outboundEmail
          ) {
            this.activity = activity as AttachmentActivity;
            this.isADBLogActivity = false;
          } else if (
            isDeviceCaptureActivity(activity) &&
            activity.details.captureType === DeviceCaptureActivityTypes.adbLogs
          ) {
            this.deviceName = activity.details.deviceName;
            this.ADBLogDate = activity.creationDate;
            this.activity = activity as AttachmentActivity;
            this.currentactivitycollection = activity.details.files as AttachmentActivity[];
            this.prepareActivityandSetDefaultActivity(activity);
            this.isADBLogActivity = true;
          } else {
            this.activity = activity as AttachmentActivity;
            this.isADBLogActivity = false;
          }
          this.getActivityHeaderName();
          this.getFileDisplayName(this.activity);
          this.showPreview(this.activity);
        }
      }
    );

    this.ticketPageService
      .getAttachmentConfig()
      .pipe(take(1))
      .subscribe((attachmentConfig: IAttachmentServiceConfig) => {
        this.maxPreviewFileSize = attachmentConfig.maxPreviewSize;
      });

    // Handle attachment deletion so we can hide previews for deleted attachments
    // Supported attachment activities
    // - regular attachments
    // - device capture activities (video rec/screen capture/adb logs & attachments for email)
    this.activityDeletedSub = this.globalEventBusService.register(
      GlobalEvents.activityDeleted,
      (activity: AttachmentActivity) => {
        if (!this.activity) {
          return;
        }

        switch (activity.activityTypeId) {
          case ActivityTypeEnum.attachment:
          case ActivityTypeEnum.outboundEmail: {
            if (activity.activityId === this.activity.activityId) {
              this.closePreview();
            }

            break;
          }
          case ActivityTypeEnum.deviceScreenshot: {
            if (activity.activityId === this.activity.parentActivityId) {
              this.closePreview();
            }

            break;
          }
          default: {
            this.$log.warn(
              'Unknown activity type: ' + activity.activityTypeId + ', for activity id = ' + activity.activityId
            );
          }
        }
      }
    );

    // On the MinimizedEnd event, the resizeTextArea resetting the scrollbar position, so I have to set the scroll bar position once the
    // resizeTextArea call is done.
    this.resizeTextAreaEndUnbind = this.globalEventBusService.register('resizeTextAreaEnd', () => {
      this.setScrollBarPosition();
    });

    /*----------------------------------------------------------------------------------------------------------- */
    this.MinimizedStartdUnbind = this.globalEventBusService.register('MinimizedStart', () => {
      this.InLoadingStateandGetScrollPosition();
    });

    // On the Associationbar Minimized, just setting the isLoading as False.
    this.associationBarMinimizedSub = this.globalEventBusService.register(GlobalEvents.associationBarMinimized, () =>
      this.setIsLoading(false)
    );

    // Clear the preview when an RC session is being maximized
    this.rcBarMinimizedSub = this.globalEventBusService.register(GlobalEvents.rcBarMinimized, () => {
      this.clearPreview();
      this.setIsLoading(false);
    });

    /*----------------------------------------------------------------------------------------------------------- */
    this.RestoredStartUnbind = this.globalEventBusService.register('RestoredStart', () => {
      this.InLoadingStateandGetScrollPosition();
    });

    this.associationBarRestoredSub = this.globalEventBusService.register(GlobalEvents.associationBarRestored, () => {
      this.setScrollBarPosition();
      this.setIsLoading(false);
    });

    this.rcBarRestoredSub = this.globalEventBusService.register(GlobalEvents.rcBarRestored, () =>
      this.setIsLoading(false)
    );
    /*----------------------------------------------------------------------------------------------------------- */

    // this.hookupDomEvents('filePreviewImage', this.$filter.transform('filePreview_Image_Error'), false);
    // this.hookupDomEvents('filePreviewVideo', this.$filter.transform('filePreview_Video_Error'), true);
    this.isLoading = false;
  }

  /** Manages previewing of different file types */
  setIsLoading = (value: boolean) => {
    this.isLoading = value;
  };

  getScrollBarPosition = () => {
    $('.preview-area').on('scroll', () => {
      this.previewAreaScrollBarHeightPosition = document.getElementById('preview-area-id').scrollHeight;
      this.previewAreaScrollBarTopPosition = document.getElementById('preview-area-id').scrollTop;
    });
  };

  setScrollBarPosition = () => {
    if (this.copypreviewAreaScrollBarHeightPosition !== 0) {
      const height = document.getElementById('preview-area-id').scrollHeight;
      document.getElementById('preview-area-id').scrollTop =
        (height * this.copypreviewAreaScrollBarTopPosition) / this.copypreviewAreaScrollBarHeightPosition;
    }
  };

  ngOnDestroy = () => {
    // Clear out any interval promises
    // this.$interval.cancel(this._intervalPromise);
    this.cancelSeachSubscription();

    if (this.MinimizedStartdUnbind) {
      this.MinimizedStartdUnbind.unsubscribe();
    }

    if (this.resizeTextAreaEndUnbind) {
      this.resizeTextAreaEndUnbind.unsubscribe();
    }

    if (this.associationBarMinimizedSub) {
      this.associationBarMinimizedSub.unsubscribe();
    }

    if (this.RestoredStartUnbind) {
      this.RestoredStartUnbind.unsubscribe();
    }

    if (this.associationBarRestoredSub) {
      this.associationBarRestoredSub.unsubscribe();
    }

    if (this.rcBarMinimizedSub) {
      this.rcBarMinimizedSub.unsubscribe();
    }

    if (this.rcBarRestoredSub) {
      this.rcBarRestoredSub.unsubscribe();
    }

    if (this.activityDeletedSub) {
      this.activityDeletedSub.unsubscribe();
    }

    if (this.attachmentPreviewUnbind) {
      this.attachmentPreviewUnbind.unsubscribe();
    }

    if (this.remoteControlStartedUnbind) {
      this.remoteControlStartedUnbind();
    }
  };

  download = () => {
    const modalSettings = this.attachmentService.createDownloadPromptConfig(
      this.activity,
      undefined,
      this.activity.$$previewId && this.isADBLogActivity
    );
    const input: hd.PromptDialogParams = modalSettings.resolve.dialogParams;
    const datetimeformat = 'YYYYMMDD[T]HH:mm:ss';
    let fileParams: FileSaveParams;
    if (this.isADBLogActivity) {
      fileParams = {
        fileName:
          this.deviceName + ' ' + input.placeHolder + ' ' + moment(new Date(this.ADBLogDate)).format(datetimeformat),
        extension: input.extension,
      };
    } else {
      fileParams = {
        fileName: this.downloadNameUtcToLocalTime(this.activity, input.placeHolder),
        extension: input.extension,
      };
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '394px';
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.closeOnNavigation = true;
    dialogConfig.data = {
      title: input.title,
      icon: input.icon,
      confirmButton: input.confirmButton,
      inputTitle: input.inputTitle,
      extension: input.extension,
      placeHolder: fileParams.fileName,
      regexFilter: input.regexFilter,
      unallowedChar: input.unallowedChar,
      fileParams,
    };
    const modalInstance = this.dialog.open(PromptDialogComponent, dialogConfig);
    modalInstance.afterClosed().subscribe((userParams: FileSaveParams) => {
      if (userParams) {
        this.attachmentService.createDownloadWithUserInput(this.activity, userParams).subscribe(
          (downloadUrl: string) => {
            // Delegate the download operation to the download file directive
            // this.globalEventBusService.broadcast('downloadFile', downloadUrl);
            const fileInfo: IFileInfo = {
              fileName: userParams.fileName + userParams.extension,
              filePath: downloadUrl,
            };
            this.attachmentService
              .downloadFile(fileInfo)
              .then(() => {
                this.$log.debug('Download successful', fileInfo.fileName);
              })
              .catch(err => {
                this.$log.debug('Failed to download', fileInfo.fileName);
                this.$log.error(err);
                this.buildFilePreviewErrorContent(FilePreviewErrorType.NotFound);
              });
          },
          (error: any) => {
            this.$log.debug('Failed to create temporary URL for file download: ' + this.activity.fileName);
            this.$log.error(error);
          }
        );
      }
    });
  };

  /** Closes the preview */
  public clearPreview = () => {
    this.onClearPreview$.next();
    this.onClearPreview$.complete();
    this.onClearPreview$ = new Subject<void>();

    this.attachmentService.clearPreviewAttachment();
    this.previewUrl = null;
    this.activity = null;
    this.isActivityIcon = false;
    this.setIsLoading(false);
  };

  closePreview = () => {
    this.attachmentPreviewClosed.emit(WorkPanelType.filePreview);
    this.clearPreview();
  };

  private fileExists = (): boolean => {
    if (this.activity && this.activity.fileName !== undefined) {
      return true;
    }
    return (
      this.activity &&
      (this.activity.details.fileName !== undefined || this.activity.details?.files[0].fileName !== undefined)
    );
  };

  isVideo = () => {
    if (this.fileExists() && this.attachmentService.isSupportedVideoType(this.activity.details?.fileName)) {
      return true;
    } else if (
      this.fileExists() &&
      this.activity.details?.files &&
      Object.keys(this.activity.details.files).includes('0')
    ) {
      return this.attachmentService.isSupportedVideoType(this.activity.details?.files[0].fileName);
    }
    return false;
  };

  isImage = (): boolean => {
    if (
      this.fileExists() &&
      (this.attachmentService.isSupportedImageType(this.activity.fileName) ||
        this.attachmentService.isSupportedImageType(this.activity.details?.fileName))
    ) {
      return true;
    } else if (
      this.fileExists() &&
      this.activity.details?.files &&
      Object.keys(this.activity.details.files).includes('0')
    ) {
      return this.attachmentService.isSupportedImageType(this.activity.details?.files[0].fileName);
    }
    return false;
  };

  isMedia = () => {
    return this.fileExists() && (this.isVideo() || this.isImage());
  };

  isLog = () => {
    if (this.fileExists() && this.attachmentService.isSupportedLogType(this.activity.fileName)) {
      return true;
    } else if (this.fileExists() && this.attachmentService.isSupportedLogType(this.activity.details?.fileName)) {
      return true;
    }
    return false;
  };

  isError = (): boolean => {
    return this.error !== undefined;
  };

  isPreviewableLog = (): boolean => {
    return this.isLog() && !this.isPreviewNotAvailable();
  };

  isPreviewNotAvailable = (): boolean => {
    return this.isNonSupportedLog() || this.isNonPreviewableLog() || this.isError();
  };

  private isNonPreviewableLog = (): boolean => {
    return this.isLog() && this.isFileTooLargeForPreview();
  };

  private isNonSupportedLog = (): boolean => {
    if (this.isADBLogActivity && this.activity) {
      return !this.attachmentService.isFileTypePreviewSupported(this.activity.fileName) && !this.isError();
    } else {
      return (
        !this.fileExists() ||
        (!this.attachmentService.isFileTypePreviewSupported(this.activity.details.fileName) && !this.isError())
      );
    }
  };

  private isFileTooLargeForPreview = (): boolean => {
    if (!this.fileExists() || !this.activity.details?.fileSize || !this.activity.fileSize || this.isError()) {
      return false;
    }

    const fileSizeMB = (this.activity.details?.fileSize ?? this.activity.fileSize) / 1024 / 1024;
    return fileSizeMB > this.maxPreviewFileSize;
  };

  private buildFilePreviewErrorContent = (errorType: FilePreviewErrorType) => {
    switch (errorType) {
      case FilePreviewErrorType.NoPreview:
        this.filePreviewErrorContent = {
          title: this.$filter.transform('filePreview_Preview_Not_Available_Title'),
          subtitle: [this.$filter.transform('filePreview_Preview_Not_Available_Subtitle')],
          imageUrl: '/sotixsight/get-resource/assets/images//no_preview.svg',
          candownload: true,
        };
        break;
      case FilePreviewErrorType.TooLarge:
        this.filePreviewErrorContent = {
          title: this.$filter.transform('filePreview_Too_Large_Title'),
          subtitle: [this.$filter.transform('filePreview_Too_Large_Subtitle')],
          imageUrl: '/sotixsight/get-resource/assets/images/file_too_large.svg',
          candownload: true,
        };
        break;
      case FilePreviewErrorType.NotFound:
        this.filePreviewErrorContent = {
          title: this.$filter.transform('filePreview_File_Not_Found_Title'),
          subtitle: [
            this.$filter.transform('filePreview_File_Not_Found_Subtitle_Line_1'),
            this.$filter.transform('filePreview_File_Not_Found_Subtitle_Line_2'),
          ],
          imageUrl: '/sotixsight/get-resource/assets/images/file_notfound.svg',
          candownload: false,
        };
        break;
      default:
        this.filePreviewErrorContent = {
          title: '',
          subtitle: [],
          imageUrl: '',
          candownload: false,
        };
        break;
    }
  };

  showSearchBarToggle = (): boolean => {
    return this.featureToggleService.isEnabled('RCPreviewLogShowSearchBar');
  };

  hookupDomEvents = (elementId: string, errorMessage: string, isVideoElement: boolean) => {
    // const element = this.$element.find('#' + elementId);
    // if (element.length === 1) {
    // Handle error event (since there is no angular equivalent event mapping)
    // element.on('error', () => {
    //   if (this.isVideo() === isVideoElement) {
    //     this.error = errorMessage;
    //   }
    // Since this is called outside of the angular lifecycle, we need to trigger a digest to force
    // our component to re-evaluate and refresh
    // if (!this.$scope.$$phase) {
    //   this.$scope.$digest();
    // }
    // });
    // Handle image load event
    // element.on('load', () => {
    //   this.error = null;
    //   if (!this.$scope.$$phase) {
    //     this.$scope.$digest();
    //   }
    // });
    // Handle video load event
    // element.on('loadstart', () => {
    //   this.error = null;
    //   if (!this.$scope.$$phase) {
    //     this.$scope.$digest();
    //   }
    // });
    // }
  };

  prepareActivityandSetDefaultActivity = (currentactivitycollection: Activity) => {
    this.fileList = [];

    for (const file of currentactivitycollection.details.files) {
      if (this.activity.activityTypeId === ActivityTypeEnum.deviceLog) {
        this.fileList.push({ caption: file.fileName });
      }
    }
    this.selectedFile = this.fileList.findIndex(x => x.caption.toUpperCase() === this.ADBFileName);
    if (this.selectedFile === -1) {
      this.selectedFile = 0;
    }
    this.activity = currentactivitycollection.details.files[this.selectedFile] as AttachmentActivity;
  };

  onClickSelectFile = (option: number) => {
    this.selectedFile = option;
    if (this.showSearchBarToggle()) {
      this.clearSearchInputText();
    }

    this.activity = this.currentactivitycollection[this.selectedFile] as AttachmentActivity;
    // this.getFileDisplayName(this.activity);
    this.showPreview(this.activity);
  };

  getFileDisplayName = (activity: AttachmentActivity) => {
    if (this.isADBLogActivity) {
      this.displayName = this.deviceName;
    } else if (activity && activity.details?.files && Object.keys(activity.details.files).includes('0')) {
      // This is typically the case for screen captures and video recordings.
      // we adjust the time stamp in the file name from UTC to local, if detected
      const fileName = activity.details.files[0].fileName;
      const idx = fileName.lastIndexOf('.');
      const fileParts = idx === -1 ? [fileName, ''] : [fileName.slice(0, idx), fileName.slice(idx)];
      this.displayName = this.downloadNameUtcToLocalTime(activity, fileParts[0]) + fileParts[1];
    } else if (activity && activity.details?.fileName) {
      // Use the actual file name if no display name exists.
      // This is typically the case for file attachments.
      this.displayName = activity.details.fileName;
    } else {
      // If we have no activity or the activity has neither a display name
      // nor a file name, use an empty string.
      // We set the emtpy string to prevent stale values in this member variable.
      this.displayName = '';
    }
  };

  getActivityDateTime = (): string => {
    if (!this.activity || !this.ADBLogDate) {
      return '';
    }
    return this.ADBLogDate;
  };

  quillEditorReady = (editor: quill.Quill) => {
    this.quillEditor = editor;
    this.editorContents = this.quillEditor.getText();
    this.quillEditor.root.addEventListener('click', ($event: Event) => {
      this.selectRowInEditor(editor);
    });

    if (this.logfileData) {
      this.quillEditor.setText(this.logfileData);
    }
  };

  quillEditorUpdate = () => {
    this.editorContents = this.quillEditor.getText();
  };

  clearSearchInputText = () => {
    this.searchInputText = '';
    this.quillEditor.removeFormat(0, this.editorContents.length - 1);
    this.results = this.foundValues = this.matchSearchedResults = [];
    this.selectedtextIndex =
      this.previousSelectedtextIndex =
      this.currentIndexSelectedbyUser =
      this.currentIndexofHighlightedtext =
        0;
    this.cancelSeachSubscription();
    this.clearTimeout();
  };

  onKeyUpPerformSearch = $event => {
    if ($event.keyCode === 8 || $event.keyCode === 46) {
      this.searchInputText = $event.target.value;
      this.onChangePerformSearch();
    } else if (!this.isValidKeyPressed($event.keyCode)) {
      $event.preventDefault();
    } else {
      this.searchInputText = $event.target.value;
      this.onChangePerformSearch();
    }
  };

  isValidKeyPressed = (keyCode: number): boolean => {
    const valid =
      (keyCode > 47 && keyCode < 58) || // number keys
      (keyCode > 64 && keyCode < 91) || // letter keys
      (keyCode > 95 && keyCode < 112) || // numpad keys
      (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
      (keyCode > 218 && keyCode < 223); // [\]' (in order)
    return valid;
  };

  onChangePerformSearch = () => {
    this.foundValues = [];
    if (this.searchInputText.length > 0) {
      const searchString = this.searchInputText;
      const regex = new RegExp(this.escapeRegExp(searchString), 'gi');
      if (searchString.length > 0) {
        this.clearFormatting();

        while (regex.exec(this.editorContents)) {
          this.foundValues.push(regex.lastIndex);
        }
        this.matchSearchedResults = [...this.foundValues];
        this.chunkArray(this.foundValues, 100, searchString.length, this.quillEditor);
      }
    } else {
      this.clearFormatting();
    }
  };

  higlighthtSearch = (UporDown: string) => {
    const pTags: any = document.getElementsByTagName('p');
    const highlightextstyle = '<span style="background-color: pink;">';

    if (this.selectedtextIndex === 0) {
      this.selectedtextIndex = this.matchSearchedResults[0];
      this.previousSelectedtextIndex = this.matchSearchedResults[this.matchSearchedResults.length - 1];
    } else {
      if (UporDown.toUpperCase() === 'DOWN') {
        this.previousSelectedtextIndex = this.selectedtextIndex;
        if (this.currentIndexofHighlightedtext >= 0) {
          this.quillEditor.formatText(
            this.currentIndexofHighlightedtext - this.searchInputText.length,
            this.searchInputText.length,
            {
              'background-color': 'yellow',
            }
          );
        }
        this.selectedtextIndex = this.matchSearchedResults.find(i => i > this.previousSelectedtextIndex);
        if (!this.selectedtextIndex) {
          this.selectedtextIndex = this.matchSearchedResults[0];
          this.previousSelectedtextIndex = this.matchSearchedResults[this.matchSearchedResults.length - 1];
        }
      } else if (UporDown.toUpperCase() === 'UP') {
        if (this.currentIndexofHighlightedtext >= 0) {
          this.quillEditor.formatText(
            this.currentIndexofHighlightedtext - this.searchInputText.length,
            this.searchInputText.length,
            {
              'background-color': 'yellow',
            }
          );
        }
        if (this.previousSelectedtextIndex === this.matchSearchedResults[0]) {
          this.previousSelectedtextIndex = this.matchSearchedResults[this.matchSearchedResults.length - 1];
          this.selectedtextIndex = this.matchSearchedResults[0];
        } else {
          this.previousSelectedtextIndex = this.matchSearchedResults
            .filter(i => i < this.selectedtextIndex)
            .sort((a, b) => b - a)[0];
        }
      }
    }

    if (UporDown.toUpperCase() === 'DOWN') {
      this.quillEditor.formatText(
        this.previousSelectedtextIndex - this.searchInputText.length,
        this.searchInputText.length,
        {
          'background-color': 'yellow',
        }
      );

      this.quillEditor.formatText(this.selectedtextIndex - this.searchInputText.length, this.searchInputText.length, {
        'background-color': 'pink',
      });

      if (this.currentIndexSelectedbyUser >= 0) {
        this.quillEditor.removeFormat(
          this.currentIndexSelectedbyUser - this.searchInputText.length,
          this.searchInputText.length
        );
      }

      this.scrolltoSearchText(pTags, highlightextstyle);
    }

    if (UporDown.toUpperCase() === 'UP') {
      this.quillEditor.formatText(this.selectedtextIndex - this.searchInputText.length, this.searchInputText.length, {
        'background-color': 'yellow',
      });

      this.quillEditor.formatText(
        this.previousSelectedtextIndex - this.searchInputText.length,
        this.searchInputText.length,
        {
          'background-color': 'pink',
        }
      );

      if (this.currentIndexSelectedbyUser >= 0) {
        this.quillEditor.removeFormat(
          this.currentIndexSelectedbyUser - this.searchInputText.length,
          this.searchInputText.length
        );
      }

      this.selectedtextIndex = this.previousSelectedtextIndex;
      this.scrolltoSearchText(pTags, highlightextstyle);
    }
  };

  selectRowInEditor = (editor: quill.Quill) => {
    if (editor.getSelection().length === 0) {
      this.currentIndexofHighlightedtext = this.selectedtextIndex;
      editor.setSelection(editor.getSelection().index, 1);
      this.currentIndexSelectedbyUser = this.selectedtextIndex = editor.getSelection().index;
    }
  };

  private scrolltoSearchText = (pTags: any, highlightextstyle: string) => {
    for (const pTag of pTags) {
      const spanTags = pTag.getElementsByTagName('span');
      for (const spanTag of spanTags) {
        if (spanTag.outerHTML.indexOf(highlightextstyle) >= 0) {
          spanTag.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      }
    }
  };

  private chunkArray = (
    foundValues: number[],
    chunk_size: number,
    searchStringLength: number,
    quillEditor: quill.Quill
  ) => {
    while (foundValues.length) {
      this.results = foundValues.splice(0, chunk_size);
      this.performSearchSubscription = this.applyFormatting(this.results, searchStringLength, quillEditor).subscribe(
        () => {}
      );
    }
  };

  private applyFormatting = (foundvalues: number[], seachstringlenth: number, editor: quill.Quill): Observable<{}> => {
    return new Observable(() => {
      foundvalues.forEach(element => {
        this.timeoutvariable.push(
          setTimeout(function () {
            editor.formatText(element - seachstringlenth, seachstringlenth, {
              'background-color': 'yellow',
            });
          })
        );
      }, 0);
    });
  };

  private clearFormatting = () => {
    this.quillEditor.removeFormat(0, this.editorContents.length - 1);
    this.cancelSeachSubscription();
    this.clearTimeout();
    this.results = this.foundValues = this.matchSearchedResults = [];
  };

  private clearTimeout = () => {
    this.timeoutvariable.forEach(x => {
      clearTimeout(x);
    });
    this.timeoutvariable = [];
    this.selectedtextIndex =
      this.previousSelectedtextIndex =
      this.currentIndexSelectedbyUser =
      this.currentIndexofHighlightedtext =
        0;
  };

  private getActivityHeaderName() {
    if (this.activity.details?.displayName !== undefined) {
      this.activitytype = this.$filter.transform('filePreview_Activitytype_Attachment');
      this.isActivityIcon = false;
    } else if (this.isADBLogActivity) {
      this.activitytype = this.$filter.transform('filePreview_Activitytype_Device_Logs');
      this.isActivityIcon = true;
    } else {
      this.activitytype = '';
      this.isActivityIcon = false;
    }
  }

  private cancelSeachSubscription() {
    if (this.performSearchSubscription) {
      this.performSearchSubscription.unsubscribe();
    }
  }

  private InLoadingStateandGetScrollPosition() {
    this.isLoading = true;
    this.getScrollBarPosition();
    this.copypreviewAreaScrollBarHeightPosition = this.previewAreaScrollBarHeightPosition;
    this.copypreviewAreaScrollBarTopPosition = this.previewAreaScrollBarTopPosition;
  }

  private escapeRegExp(inputData: string) {
    return inputData.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  isFilePreviewAreaVisible = (): boolean => {
    return this.previewUrl !== undefined || this.error !== undefined;
  };

  private showPreview = (activity: AttachmentActivity) => {
    this.onClearPreview$.next();
    this.onClearPreview$.complete();
    this.onClearPreview$ = new Subject<void>();

    // Clear the error, so we allow new content to be loaded
    this.error = undefined;
    this.buildFilePreviewErrorContent(FilePreviewErrorType.None);

    if (activity) {
      this.setIsLoading(true);
      this.logfileData = '';

      let serviceDownloadCall;

      if (this.isVideo()) {
        serviceDownloadCall = this.attachmentService.createStreamDownload(activity);
      } else {
        serviceDownloadCall = this.attachmentService.createDownload(activity);
      }

      // Create a temorary download URL for the attachment that we can use as a preview URL
      serviceDownloadCall
        .then((downloadUrl: string) => {
          // If there's an RC session visible, minimize it
          const state = this.deviceStateRegistry.getConnectedOrErrorState();
          if (state && !state.poppedOut) {
            // if RC isn't minimized, force to it minimize
            if (!state.minimized) {
              this.deviceStateRegistry.minimizeToggle(state.device, true);
            }
          }

          this.previewUrl = downloadUrl;

          // if (this.attachmentService.isSupportedVideoType(activity.fileName)) {
          //   // Set timer and extend if time has passed
          //   if (this._intervalPromise) {
          //     this.$interval.cancel(this._intervalPromise);
          //     this._intervalPromise = null;
          //   }
          // }

          // ADB log files load asynchronously, so we only finished loading when its not a log file
          if (this.isLog()) {
            if (this.isFileTooLargeForPreview()) {
              this.buildFilePreviewErrorContent(FilePreviewErrorType.TooLarge);
              this.setIsLoading(false);
            } else {
              this.getLogFileData(downloadUrl);
            }
          } else if (this.isImage()) {
            // do nothing
          } else if (this.isVideo()) {
            this.attachmentService.getConfig().subscribe(
              (result: IAttachmentServiceConfig) => {
                this.createExtendInterval(result.downloadExpiryMilliseconds, activity);
              },
              error => {
                this.createExtendInterval(this._minimumDownloadExtendInterval, activity);
              }
            );
          } else {
            this.setIsLoading(false);
            this.buildFilePreviewErrorContent(FilePreviewErrorType.NoPreview);
          }
        })
        .catch((error: any) => {
          // We will show a specific "missing file" if the file is missing (404)
          if (error.status !== 404) {
            this.clearPreview();
            this.$log.debug('Failed to create download for file preview: ' + activity.fileName);
            this.$log.error(error);
          } else {
            error.isHandled = true;
            this.error = error.error_description;

            this.buildFilePreviewErrorContent(FilePreviewErrorType.NotFound);

            // If there's an RC session visible, minimize it
            const state = this.deviceStateRegistry.getConnectedOrErrorState();
            if (state) {
              if (!state.poppedOut && !state.minimized) {
                this.deviceStateRegistry.minimizeToggle(state.device, true);
              }
            }
          }
          this.setIsLoading(false);
        });
    } else {
      // Preview cleared
      this.clearPreview();
    }
  };

  private createExtendInterval = (downloadExpiryMilliseconds: number, activity: AttachmentActivity): void => {
    // extend API is light, refresh frequently enough to allow one failed attempt
    const refreshMs = Math.floor(downloadExpiryMilliseconds * 0.45);
    interval(refreshMs)
      .pipe(
        takeUntil(this.onClearPreview$),
        switchMap(() => this.attachmentService.extendDownloadTimeSpan(activity))
      )
      .subscribe();
  };

  private getLogFileData = (downloadUrl: string) => {
    if (this.isLog()) {
      this.setIsLoading(true);
      this.attachmentService.fetchLogFileData(downloadUrl).subscribe((logFileData: string) => {
        const chunk_size = this.defineChunkSize(logFileData.length);
        this.logfileData = logFileData.substring(0, chunk_size);

        if (this.quillEditor) {
          this.quillEditor.setText(this.logfileData);
        }

        this.asyncLoadingRestofFileData(logFileData.substring(chunk_size + 1, logFileData.length));
        this.setIsLoading(false);
      });
    }
  };

  private async asyncLoadingRestofFileData(remainingdata: string) {
    await this.promisetoreturntherestoffiledata(remainingdata).then(() => {
      setTimeout(() => {
        this.isLoadingRemaingtext = false;
      }, 1);
      // this.$rootScope.$apply();
      clearTimeout(this.timeoutId);
    });
  }

  private promisetoreturntherestoffiledata(remainingdata: string) {
    this.isLoadingRemaingtext = true;
    return new Promise(resolve => {
      this.timeoutId = setTimeout(() => {
        this.logfileData = this.logfileData.concat(remainingdata);
        if (this.quillEditor) {
          this.quillEditor.setText(this.logfileData);
        }
        resolve('resolved');
      }, 0);
    });
  }

  private defineChunkSize = (logFileLength: number): number => {
    let chunk_size = 0;
    switch (true) {
      case logFileLength < 100000:
        chunk_size = 1000;
        break;
      case logFileLength >= 100000 && logFileLength < 1000000:
        chunk_size = 2000;
        break;
      case logFileLength >= 1000000:
        chunk_size = 5000;
        break;
    }
    return chunk_size;
  };

  // video capture files are uploaded with timestamped names, in order to avoid name collision
  // (video files do not have API assigned GUID names, inlike other uploaded files).
  // That timestamp is in UTC, and needs to be converted to local time
  private downloadNameUtcToLocalTime = (activity: Activity, fileName: string): string => {
    if (
      isDeviceCaptureActivity(activity) &&
      (DeviceCaptureActivityTypes.video === activity.details.captureType ||
        DeviceCaptureActivityTypes.audiovideo === activity.details.captureType)
    ) {
      const rTimestamp = /_20[2-9]\d[0-1]\d[0-3]\d_[0-2]\d[0-6]\d[0-6]\d$/;
      const timestamps = fileName.match(rTimestamp);
      if (timestamps && timestamps.length > 0) {
        const timestamp = timestamps.pop();
        const date = moment.utc(timestamp.slice(1), 'YYYYMMDD_HHmmss');
        if (date.isValid()) {
          const localTimestamp = date.local().format('YYYYMMDD_HHmmss');
          return fileName.slice(0, -timestamp.length) + '_' + localTimestamp;
        }
      }
    }
    return fileName;
  };
}
